const entity = {
    create_failed: 'Falha ao criar {{name}}.',
    not_exists: 'O {{name}} não existe.',
    not_exists_with_id: 'O {{name}} com ID `{{id}}` não existe.',
    not_found: 'O recurso não existe.',
};
export default entity;
